import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_BASE_URL } from '../config'
import { getSessionTokens } from './sessionTokens'
import { notifyIfForbidden } from './forbiddenNotice'

const parseBody = async (response) => {
    const text = await response.text()
    if (text === '') {
        return null
    }
    try {
        return JSON.parse(text)
    } catch (error) {
        return text
    }
}

const rawBaseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    responseHandler: parseBody
})

export const baseQuery = async (args, api, extraOptions = {}) => {
    const request = typeof args === 'string' ? { url: args } : { ...args }
    const tokens = await getSessionTokens()
    const token = tokens && (extraOptions.token === 'id' ? tokens.idToken : tokens.accessToken)

    if (token) {
        request.headers = { ...request.headers, authorization: `Bearer ${token}` }
    }

    const result = await rawBaseQuery(request, api, extraOptions)
    notifyIfForbidden(result, api)
    return result
}
